export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5005';

export const FINANCE_NAME =
  process.env.REACT_APP_FINANCE_NAME || 'SHREE DHANESHWARI FINANCE AND LEASING';

